import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {NgxUiLoaderModule} from 'ngx-ui-loader';
import {
  ModalConfirmationComponent
} from './components/main/partials/modals/modal-confirmation/modal-confirmation.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxUiLoaderModule,
    ModalConfirmationComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  protected title = 'TCS - Toll Control System';
}
